<script>
/**
 * Reports-View-Report1 component
 */
import axios from '@/axios'
import { apiUrl } from '@/state/helpers'

import priceMixin from '@/mixins/priceMixin'
import tidMixin from '@/mixins/tidMixin'

import PagingFilter from "@/components/filter/paging-filter";
import pagingFilterMixin from "@/mixins/pagingFilterMixin";
import { EventBus } from "@/event-bus";
import moment from "moment";

export default {
    components: { PagingFilter },
    mixins: [priceMixin, tidMixin, pagingFilterMixin],

    data() {
        return {
            s_date_report: -1,
            e_date_report: -1,
            selected_tids: [],
            totalRowsChash: 0,

            reportData:[],
            reportRacunData:[],

            racunDetailBuisy:false,

            racunTitle:`${this.$t('label.report_racun_ico_details')}`,
            racunId: 0,

            fields: [
                {
                    key: "rtime",
                    label: this.$t("label.report_racun_table_h_time"),
                    sortable: false,
                },
                {
                    key: "total",
                    label: this.$t("label.report_racun_table_h_amount"),
                    sortable: false,
                },
                { 
                    key: "transtype",
                    label: this.$t("label.report_racun_table_h_type"),
                    sortable: false,
                },
                {
                    key: "rcode",
                    label: this.$t("label.report_racun_table_h_code"),
                    sortable: false,
                },
                {
                    key: "details",
                    label: this.$t("label.report_racun_table_h_details"),
                    sortable: false,
                }
            ],

            transaction_types: [
                this.$t("label.report_tt_0"),
                this.$t("label.report_tt_1"),
            ],

            invoice_types: [
                this.$t("label.report_it_0"),
                this.$t("label.report_it_1"),
                this.$t("label.report_it_2"),
                this.$t("label.report_it_3"),
                this.$t("label.report_it_4"),
            ],

            pay_types: {
                  0: `${this.$t('label.report_p_m_0')}`,
                  1: `${this.$t('label.report_p_m_1')}`,
                  2: `${this.$t('label.report_p_m_2')}`,
                  3: `${this.$t('label.report_p_m_3')}`,
                  4: `${this.$t('label.report_p_m_5')}`,
                  5: `${this.$t('label.report_p_m_6')}`,
            },

          rd_list_data: {},
          /*   'trans_time':'',
            'inv_id':'',
            'amount_total':0,
            'inv_trans_type':'',
            'casier':'',
            'pfr_time':'',
            'pay_type_label':'',
            'pay_sum':0,
            'change':0,
          }, */

          r_d_data:[],

      }
    },

    mounted() {
        /**
        * For paging management
        */
        EventBus.$on("pagingfilterVal", (data) => {
        this.perPage = data;
        });

        /**
         * For hiding searchbox for POS module
         */
        this.showsearchbox = false;
        EventBus.$emit("showsearchbox", this.showsearchbox);

        this.selected_tids = this.setSelectedTids(this.$store.state.reports.selectedTids.tids);
        this.report_type = this.$store.state.reports.reportType.repType;
        this.setReportTime();

        axios.defaults.headers.common = {
            Authorization: `Bearer ${this.$store.state.authapi.user.token}`,
        }

        this.fetchData();
    },

    watch: {
      currentPage: {
        handler: function () {
          //this.isBusy = !this.isBusy;
          //console.log(this.currentPage, "WATCHER CurrentOage");
          this.fetchData();
        },
      },
      // eslint-disable-next-line no-unused-vars
      perPage: function (val, oldval) {
        //console.log(val, "< val oldval>", oldval);
        this.totalRows = val;
        this.fetchData();
      },
    },

    methods: { 
        setReportTime(){
            if(this.$store.state.reports.reportDays.startDay == -1){
                this.s_date_report = -1;
            }else{
                this.s_date_report = Math.floor(new Date(this.$store.state.reports.reportDays.startDay).getTime() / 1000);
            }

            if(this.$store.state.reports.reportDays.endDay == -1){
                this.e_date_report = -1;
            }else{
                this.e_date_report = Math.floor(new Date(this.$store.state.reports.reportDays.endDay).getTime() / 1000);
            }
        },

        viewdetails(id, list_data){
          this.racunId = id;
          this.rd_list_data = list_data;
          this.$refs['detail-modal'].show();
          this.fetchRacunData();
        },

        displayPaymentType(key){
          return this.pay_types[key];
        },

        async fetchData(){
            this.isBusy = !this.isBusy;

          await axios
            .post(`${apiUrl}/reports/listing`, {
                "from": this.s_date_report,
                "to": this.e_date_report,
                "tids": this.selected_tids,
                "page": this.currentPage,
                "limit": this.perPage,
                "dir": "desc"
                
            })
            .then((response) => {
                var res = JSON.parse(JSON.stringify(response.data))
                this.reportData = [];
                //let ob_date = '';
                //let count = 0;
                console.log(res);
                Object.entries(res.results).forEach(([key, value]) => {
                  let r_time = new Date(value.Trans_time * 1000);
                  let pfr_time = moment.utc(moment(r_time).utc()).format("DD-MMM-YYYY HH:mm:ss");
                  let rs_time = moment.utc(r_time).local().format("DD-MMM-YYYY HH:mm:ss");
                  

                  let ptypearr = value.pay_types.split(";");
                  let ptype = ptypearr[0].split(":")[0];
                  let pay_amount = this.formatNumberDispaly(Number(ptypearr[1]));
                  let trans_type = this.invoice_types[value.inv_type] + ' - ' + this.transaction_types[value.trans_type];

                  //console.log(key, "<-key val->",value);
                  this.reportData.push({
                      un:key,
                      trans_id:value.trans_id, 
                      rtime:rs_time, 
                      total:this.formatNumberDispaly(value.amount_total), 
                      rcode:value.inv_id, 
                      pfrtime:pfr_time,
                      transtype:trans_type,
                      payamount:pay_amount,
                      pytype:ptype,
                      casier:value.cashier,
                      paysum:pay_amount,
                      change:this.formatNumberDispaly(value.change)
                    });
                });
            
                //console.log(this.itemsData);
                
                if(this.currentPage === 1) this.totalRowsChash = res.total;
                this.totalRows = this.totalRowsChash;
                this.isBusy = !this.isBusy;
            }).catch((error) => {
            this.isBusy = !this.isBusy;

            // console.log("error", error);
            // console.log(error.response);

            if (error.response != undefined && error.response.status === 401) {
                this.$store.dispatch('authapi/logoutauthapi')
                this.$router.push('/login')
            } else if (
                error.response != undefined &&
                error.response.status === 400
            ) {
                // toastMixin.methods.displayToastAlert(error.response.data, "error");
            } else {
                // toastMixin.methods.displayToastAlert(
                //   this.$t("alerts.something_went_wrong"),
                //   "error"
                // );
            }
            })

            window.scrollTo({ top: 0, behavior: "smooth" });
        },

        async fetchRacunData(){
          this.racunDetailBuisy = true;
          this.reportRacunData = [];
          await axios
            //POST request koji za parametar prima GET promanjivu ?!? 
            .get(`${apiUrl}/reports/getarticles?transid=`+this.racunId)
            .then((response) => {
              var resRacun  = JSON.parse(JSON.stringify(response.data));
              this.reportRacunData = [];
              
                Object.entries(resRacun).forEach(([key, value]) => {
                 
                  let jedinicna_cena = Number(value.total) / Number(value.quantity);

                  this.reportRacunData.push( {
                              uni:key, 
                              external_id:value.external_id,
                              name:value.name,
                              unit:value.unit,
                              total:value.total,
                              quantity:value.quantity,
                              unit_price:this.formatNumberDispaly(jedinicna_cena)
                      });
                }); 
                
                this.racunDetailBuisy = !this.racunDetailBuisy;
            }).catch((error) => {
              this.racunDetailBuisy = !this.racunDetailBuisy;

            // console.log("error", error);
            // console.log(error.response);

            if (error.response != undefined && error.response.status === 401) {
                this.$store.dispatch('authapi/logoutauthapi')
                this.$router.push('/login')
            } else if (
                error.response != undefined &&
                error.response.status === 400
            ) {
                // toastMixin.methods.displayToastAlert(error.response.data, "error");
            } else {
                // toastMixin.methods.displayToastAlert(
                //   this.$t("alerts.something_went_wrong"),
                //   "error"
                // );
            }
            })
        }
    }
}
</script>
<template>
    <div class="bg-white mb-2 p-4">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                   <PagingFilter />
                  <div class="table-responsive mb-0">
                    <b-table
                      class="datatables"
                      :items="reportData"
                      :fields="fields"
                      responsive="sm"
                      :per-page="0"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :busy="isBusy"
                      :no-local-sorting="true"
                      @head-clicked="headClicked"
                    >
                        <template #table-busy>
                          <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong class="pl-2">&nbsp;{{ $t("label.loading") }}</strong>
                          </div>
                        </template>
                        <template #top-row v-if="reportData.length === 0">
                          <td
                            :colspan="fields.length"
                            class="text-center"
                          >
                            <div class="text-center my-2">
                              <h3 class="text-danger pl-2 align-middle">{{ $t("label.report_no_results") }}</h3>
                            </div>
                          </td>
                        </template>
                        <template #cell(details)="row">
                          <a
                            v-tooltip.top="$t('label.report_racun_ico_details')"
                            role="button"
                            @click="
                              viewdetails(
                                row.item.trans_id,
                                {
                                  'trans_time':row.item.rtime,
                                  'inv_id':row.item.rcode,
                                  'amount_total':row.item.total,
                                  'inv_trans_type':row.item.transtype,
                                  'casier':row.item.casier,
                                  'pfr_time':row.item.pfrtime,
                                  'pay_type_label':row.item.pytype,
                                  'pay_sum':row.item.paysum,
                                  'change':row.item.change
                                }
                              )
                            "
                          >
                          <i class="fas fa-info-circle"></i>
                          </a>
                        </template>
                    </b-table>
                </div>
              </div>

            <div class="row" v-if="reportData.length !== 0">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers">
                  <ul
                    class="pagination pagination-rounded justify-content-center mt-4"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- <b-button v-b-modal.modal-1>Launch demo modal</b-button> -->
            <!-- MODAL DETALJI RACUNA -->
            <b-modal ref="detail-modal" id="modal-1" ok-only>
              <template #modal-header="{ close }">
                <h2>{{ $t('label.report_racun_ico_details') }}</h2>
              </template>
              <!-- samo za test !!!! -->
              <!-- <p>{{ this.racunId }}</p> -->
              <div class="d-flex justify-content-between">
                <div>{{ this.rd_list_data.trans_time }}</div>
                <div>{{ this.rd_list_data.inv_id }}</div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="fs-4 fw-bold">{{ this.rd_list_data.amount_total }}</div>
                <div>{{ this.rd_list_data.inv_trans_type }}</div>
              </div>
              <hr />
              <p class="fs-4 fw-bold my-4">{{ this.rd_list_data.casier }}</p>
              <div class="fs-4 d-flex justify-content-between mb-4">
                <div>{{ $t('label.report_PFR_time') }}</div>
                <div>{{ this.rd_list_data.pfr_time }}</div>
              </div>
              <div>
                <div class="fs-5">{{ $t('label.report_items_heading') }}</div>
                <div class="fs-5 d-flex justify-content-between">
                    <div class="w-25" style="text-align: right;">{{ $t('label.unit_price') }}</div>
                    <div class="w-25" style="text-align: center;">{{ $t('label.report_items_table_h_quantity') }}</div>
                    <div class="w-50" style="text-align: right;">{{ $t('label.report_p_m_table_h_total') }}</div>
                </div>
              </div>
              <template v-if="this.racunDetailBuisy">
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="pl-2">&nbsp;{{ $t("label.loading") }}</strong>
                </div>
              </template>
              <template v-if="reportRacunData.length !== 0">
                <div v-for="rditem in this.reportRacunData" :key="rditem.id" >
                  <hr />
                  <div class="fs-5">{{ rditem.external_id }} : {{ rditem.name }} ({{ rditem.unit }})</div>
                  <!-- OVDE DODATI USLOV ZA PORESKO UMANJNJE -->
                  <!-- <div v-if="rditem.tax_labels === 'N'">
                    <div class="fs-5 text-secondary" style="margin-left: 34px;"> Iznos - 10%</div>
                  </div> -->
                  <div class="fs-5 d-flex justify-content-between">
                      <div class="w-25" style="text-align: right;">{{ rditem.unit_price }}</div>
                      <div class="w-25" style="text-align: center;">{{ rditem.quantity }}</div>
                      
                      <div class="w-50" style="text-align: right;">{{ rditem.total }}</div>
                  </div>
                </div>
              </template>
              <p>&nbsp;</p>
              <div class="pt-2 my-2 fs-5 text-secondary border-top border-dark">Placanje</div>
              <div class="fs-4 my-2 d-flex justify-content-between">
                <div>{{ this.displayPaymentType(this.rd_list_data.pay_type_label) }}</div>
                <div class="fw-bold">{{ this.rd_list_data.pay_sum }}</div>
              </div>
              <hr />
              <div class="fs-4 my-2 d-flex justify-content-between">
                <div>{{ $t('label.report_racun_change') }}</div>
                <div class="fw-bold">{{ this.rd_list_data.change }}</div>
              </div>

            </b-modal>

            </div>
          </div>
        </div>
    </div>
</template>